






































































































































































































































































































































import {
  Vue, Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import moment from 'moment';
import _ from 'lodash';

import SelectUsers from '@/components/selectusers.vue';
import SelectStadium from '@/components/selectstadium.vue';
import mAreaPicker from '@/components/mareapicker.vue';

import MyCommon from '@/mixins/common';

@Component({
  components: {
    SelectUsers,
    SelectStadium,
    mAreaPicker,
  },
})
export default class extends Mixins(MyCommon) {
  @Prop() value!: any;

  // 可选的规则项
  @Prop() validRules!: string[];

  rules: any[] = this.value || [];

  // moment: any = moment

  // 操作符下拉
  operators: any = [
    { value: 'eq', name: '等于' },
    { value: 'neq', name: '不等于' },
    { value: 'contain', name: '包含' },
    { value: 'notcontain', name: '不包含' },
    { value: 'gt', name: '大于' },
    { value: 'ge', name: '大等于' },
    { value: 'lt', name: '小于' },
    { value: 'le', name: '小等于' },
    { value: 'between', name: '在...之间' },
    { value: 'notbetween', name: '不在...之间' },
    { value: 'is', name: '是' },
    { value: 'isnot', name: '不是' },
    { value: 'belongto', name: '属于' },
    { value: 'notbelongto', name: '不属于' },
  ];

  // 规则项下拉
  ruleItems: any = {
    user_id: {
      name: '用户ID',
      operator: ['eq', 'neq', 'contain', 'notcontain', 'gt', 'ge', 'lt', 'le'],
    },
    stadium_id: {
      name: '场馆ID',
      operator: ['eq', 'neq', 'contain', 'notcontain', 'gt', 'ge', 'lt', 'le'],
    },
    stadium_user_c: {
      name: '场馆用户',
      operator: ['belongto', 'notbelongto'],
    },
    date: {
      name: '日期',
      operator: ['eq', 'neq', 'gt', 'ge', 'lt', 'le'],
    },
    weekday: {
      name: '星期',
      operator: ['eq', 'neq', 'contain', 'notcontain', 'gt', 'ge', 'lt', 'le'],
    },
    hour: {
      name: '小时',
      operator: ['eq', 'neq', 'contain', 'notcontain', 'gt', 'ge', 'lt', 'le'],
    },
    starttime: {
      name: '开始时间',
      operator: ['eq'],
    },
    endtime: {
      name: '结束时间',
      operator: ['eq'],
    },
    area: {
      name: '地区',
      operator: ['contain', 'notcontain'],
    },
    ip: {
      name: 'IP地址',
      operator: ['contain', 'notcontain'],
    },
    mobile: {
      name: '手机号',
      operator: ['eq', 'contain'],
    },
    ordertime: {
      name: '下单时间',
      operator: ['between', 'notbetween'],
    },
    curator: {
      name: '馆长',
      operator: ['is'],
    },
    player: {
      name: '球友',
      operator: ['is', 'isnot'],
    },
    user_type: {
      name: '用户类型',
      operator: ['is', 'isnot'],
    },
    app_platform: {
      name: '平台',
      operator: ['is', 'isnot'],
    },
  };

  curatorOptions: any[] = [
    { value: 1, name: '未注册' },
    { value: 2, name: '已注册' },
    { value: 3, name: '已注册，未申请入驻' },
    { value: 4, name: '已申请入驻，营业资质未提交' },
    { value: 5, name: '已申请入驻，审核未通过' },
    { value: 6, name: '审核已通过，未进入首页' },
    { value: 7, name: '进入首页' },
  ];

  playerOptions: any[] = [
    { value: 1, name: '未注册' },
    { value: 2, name: '已注册' },
    { value: 3, name: '已登录' },
    { value: 4, name: '订过场' },
    { value: 5, name: '被邀请打球' },
    { value: 6, name: '用过小羽组局' },
    { value: 7, name: '小羽组局成功' },
    { value: 8, name: '被感知组局通知' },
    { value: 9, name: '响应过感知组局' },
    { value: 10, name: '已实名认证' },
    { value: 11, name: '已录入人脸' },
  ];

  userTypeOptions: any[] = [
    { value: 1, name: '球友' },
    { value: 2, name: '馆长' },
  ];

  appPlatforms: any[] = [
    { value: 1, name: '苹果' },
    { value: 2, name: '安卓' },
  ];

  @Watch('value')
  watchValue(val: any, oldVal: any) {
    if (val) {
      this.rules = val;
    }
  }

  inArray(arr: any, val: any) {
    if (_.indexOf(arr, val) > -1) {
      return true;
    }
    return false;
  }

  add() {
    this.rules.push({
      rule_relation: 'and',
      rule_name: '',
      rule_operator: '',
      rule_value: '',
      rule_sort: this.rules.length + 1,
    });

    this.$emit('change', this.rules);
  }

  remove(idx: number) {
    this.$confirm({
      title: '确认信息',
      content: '确定要删除规则吗？',
      onOk: () => {
        this.rules.splice(idx, 1);

        this.$emit('change', this.rules);
      },
    });
  }

  renderRuleValue(rule: any, defaultVal: any) {
    const ruleValue: any = rule.rule_value;
    if (ruleValue && ruleValue !== '') {
      if (['ordertime'].includes(rule.rule_name)) {
        return [
          moment(ruleValue[0], 'YYYY-MM-DD HH:mm:ss'),
          moment(ruleValue[1], 'YYYY-MM-DD HH:mm:ss'),
        ];
      }
      if (['starttime', 'endtime'].includes(rule.rule_name)) {
        return moment(ruleValue, 'YYYY-MM-DD HH:mm:ss');
      }
      try {
        return JSON.parse(ruleValue);
      } catch (e) {
        return ruleValue;
      } finally {
        // eslint-disable-next-line no-unsafe-finally
        return ruleValue;
      }
    } else {
      return defaultVal;
    }
  }

  changeRuleRelation(idx: number, val: any) {
    _.set(this.rules, [idx, 'rule_relation'], val);
    this.$emit('change', this.rules);
  }

  // 修改规则项
  changeRuleName(idx: number, val: any) {
    _.set(this.rules, [idx, 'rule_name'], val);
    _.set(this.rules, [idx, 'rule_operator'], '');
    _.set(this.rules, [idx, 'rule_value'], '');

    this.$emit('change', this.rules);
  }

  // 修改规则项的操作符
  changeRuleOperator(idx: number, val: any) {
    // 比较两次的操作符
    const rulename = _.get(this.rules, [idx, 'rule_name']);
    const oldoperator = _.get(this.rules, [idx, 'rule_operator']);
    const oldvalue = _.get(this.rules, [idx, 'rule_value']);
    if (!['between', 'notbetween', 'is', 'isnot'].includes(oldoperator)) {
      if (['contain', 'notcontain'].includes(oldoperator)) {
        // 如果原来和新的都是包含和不包含的话，不改变值
        if (['contain', 'notcontain'].includes(val)) {
          if (['ip', 'mobile'].includes(rulename) === false) {
            _.set(this.rules, [idx, 'rule_value'], []);
          }
        } else if (['ip', 'mobile'].includes(rulename)) {
          _.set(this.rules, [idx, 'rule_value'], '');
        } else {
          _.set(this.rules, [idx, 'rule_value'], '');
        }
      } else if (['contain', 'notcontain'].includes(val)) {
        // 如果新的选择是多选值
        // console.log('这种情况')
        if (['ip', 'mobile'].includes(rulename) === false) {
          _.set(this.rules, [idx, 'rule_value'], []);
        }
      } else {
        // 如果新的选择是单值
        if (['date', 'starttime', 'endtime', 'ordertime'].includes(rulename)) {
          _.set(this.rules, [idx, 'rule_value'], null);
        } else if (['ip', 'mobile'].includes(rulename)) {
          _.set(this.rules, [idx, 'rule_value'], '');
        } else if (['curator', 'player'].includes(rulename)) {
          _.set(this.rules, [idx, 'rule_value'], []);
        } else {
          _.set(this.rules, [idx, 'rule_value'], '');
        }
      }
    }

    _.set(this.rules, [idx, 'rule_operator'], val);

    // console.log(this.rules)
    this.$emit('change', this.rules);
  }

  changeRuleValue(idx: number, val: any) {
    const obj: any = _.get(this.rules, [idx]);
    if (obj.rule_name === 'ordertime') {
      if (val.length === 0) {
        _.set(this.rules, [idx, 'rule_value'], null);
      } else {
        _.set(
          this.rules,
          [idx, 'rule_value'],
          [
            `${val[0].format('YYYY-MM-DD')} 00:00:00`,
            `${val[1].format('YYYY-MM-DD')} 23:59:59`,
          ],
        );
      }
    } else if (['starttime', 'endtime'].includes(obj.rule_name)) {
      if (val) {
        _.set(
          this.rules,
          [idx, 'rule_value'],
          val.format('YYYY-MM-DD HH:mm:ss'),
        );
      } else {
        _.set(this.rules, [idx, 'rule_value'], null);
      }

      // } else if (['ip', 'mobile'].includes(obj.rule_name)) {
    } else {
      _.set(this.rules, [idx, 'rule_value'], val);
    }
    this.$emit('change', this.rules);
  }

  changeRuleSort(idx: number, val: any) {
    _.set(this.rules, [idx, 'rule_sort'], val);

    this.$emit('change', this.rules);
  }

  // mounted() {
  //   console.log(this.rules)
  //   console.log(this.validRules)
  // }
}
